import styled, { css } from 'styled-components';
import theme from '../themes/theme';

export const RadioButtonContainer = styled.div`
  position: relative;
  margin-right: 12px;
`;

export const Label = styled.label`
  font-size: ${theme.fontSizes[0]}px;
  color: ${theme.colors.deepLakeBlue[100]};
  font-family: ${theme.fontPrimary};
  line-height: 1.58;
`;

export const InnerCircle = styled.div`
  background-color: white;
  border-radius: 50%;
  height: 0;
  width: 0;
  transition: width 0.2s ease-in, height 0.2s ease-in;
`;

export const CustomInput = styled.div`
  border: 1px solid ${theme.colors.preciousStoneBlue[100]};
  background-color: white;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ error }) => {
    if (error) {
      return css`
        border-color: ${theme.colors.errorOrange};
      `;
    }
  }}
`;

export const Input = styled.input`
  opacity: 0;
  z-index: 2;
  width: 16px;
  height: 16px;
  position: absolute;
  cursor: pointer;
  margin: 0;

  &:checked {
    & ~ ${CustomInput} {
      border: 0;
      background-image: radial-gradient(circle at 50% 50%, #79c5cc, #2f93ab 56%, #005d78 71%);

      ${InnerCircle} {
        height: 8px;
        width: 8px;
      }
    }
  }
`;
